import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DEFAULT_GRADE } from 'src/constants/grades.constants';
import { GRADES } from 'src/interfaces/grades.types';
import { GradeState } from 'src/interfaces/store.types';
import type { RootState } from 'src/store';
import { useAppSelector } from 'src/store/redux';

const initialState: GradeState = {
  currentGrade: DEFAULT_GRADE,
  isGradeDefined: false,
};

export const currentGradeSlice = createSlice({
  name: 'currentGrade',
  initialState,
  reducers: {
    setCurrentGrade: (state, action: PayloadAction<GRADES>) => {
      state.currentGrade = action.payload;
    },
    setIsGradeDefined: (state, action: PayloadAction<boolean>) => {
      state.isGradeDefined = action.payload;
    },
  },
});

export const { setCurrentGrade, setIsGradeDefined } = currentGradeSlice.actions;

export const useCurrentGradeSelector = () =>
  useAppSelector((state: RootState) => state.currentGrade.currentGrade);

export const useIsGradeDefinedSelector = () =>
  useAppSelector((state: RootState) => state.currentGrade.isGradeDefined);

export default currentGradeSlice.reducer;
